"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacebookPost1Schema = void 0;
exports.FacebookPost1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/facebook-socialembed-post/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "FacebookPost1",
    "description": "Embed a facebook post",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:facebook-socialembed-post:1"
            ]
        },
        "attributes": {
            "type": "object",
            "properties": {
                "facebookEntityType": {
                    "type": "string",
                    "enum": [
                        "comment",
                        "event",
                        "photo",
                        "post",
                        "video"
                    ]
                },
                "href": {
                    "type": "string",
                    "description": "URL of Facebook post to embed. See https://developers.facebook.com/docs/plugins/embedded-posts#how-to-get-a-posts-url"
                }
            },
            "required": [
                "facebookEntityType",
                "href"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9mYWNlYm9vay1zb2NpYWxlbWJlZC1wb3N0LzEuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsbUJBQW1CLEdBQUc7SUFDakMsS0FBSyxFQUFFLDhGQUE4RjtJQUNyRyxTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxlQUFlO0lBQ3hCLGFBQWEsRUFBRSx1QkFBdUI7SUFDdEMsTUFBTSxFQUFFLFFBQVE7SUFDaEIsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFO2dCQUNOLHNEQUFzRDthQUN2RDtTQUNGO1FBQ0QsWUFBWSxFQUFFO1lBQ1osTUFBTSxFQUFFLFFBQVE7WUFDaEIsWUFBWSxFQUFFO2dCQUNaLG9CQUFvQixFQUFFO29CQUNwQixNQUFNLEVBQUUsUUFBUTtvQkFDaEIsTUFBTSxFQUFFO3dCQUNOLFNBQVM7d0JBQ1QsT0FBTzt3QkFDUCxPQUFPO3dCQUNQLE1BQU07d0JBQ04sT0FBTztxQkFDUjtpQkFDRjtnQkFDRCxNQUFNLEVBQUU7b0JBQ04sTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLGFBQWEsRUFBRSx1SEFBdUg7aUJBQ3ZJO2FBQ0Y7WUFDRCxVQUFVLEVBQUU7Z0JBQ1Ysb0JBQW9CO2dCQUNwQixNQUFNO2FBQ1A7U0FDRjtLQUNGO0lBQ0QsVUFBVSxFQUFFO1FBQ1YsWUFBWTtRQUNaLE1BQU07S0FDUDtDQUNGLENBQUEifQ==